import python from "./data/images/python.svg"
import cpp from "./data/images/cpp.svg"
import matlab from "./data/images/matlab.svg"
import tensorFlow from "./data/images/tensorflow.svg"
import ros from "./data/images/ros.svg"
import raspberry from "./data/images/raspberry.svg"
import ubuntu from "./data/images/ubuntu.svg"
import arduino from "./data/images/arduino.svg"
import opencv from "./data/images/opencv.svg"
import git from "./data/images/git.svg"
import pytorch from "./data/images/pytorch.svg"
import js from "./data/images/js.svg"
import react from "./data/images/react.svg"

const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://www.linkedin.com/in/m-javad-sameri/',
  title: ' ',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Javad',
  role: 'Machine Learning Engineer',
  description:
    'A Graduate of Artificial Intelligence and Robotics experienced with signal processing and software development. Also an electronic enthusiast.',
  quote:
    'It\'s pointless to have a nice clean desk, because it means you\'re not doing anything.',
  quoteName:'Michio ',
  quoteFamily:'Kaku',
  
  resume: 'https://mj-sam.github.io/resume.pdf',
  social: {
    linkedin: 'https://www.linkedin.com/in/m-javad-sameri/',
    github: 'https://github.com/mj-sam',
  },
}


const skills = [
  {
    "id": 0,"skillName": "Python","amount": "95","img": python
  },
  {
    "id": 1,"skillName": "C++","amount": "90","img": cpp
  },
  {
    "id": 2,"skillName": "MATLAB","amount": "90","img": matlab
  },
  {
    "id": 3, "skillName": "TensorFlow", "amount": "85","img": tensorFlow
  },
  {
    "id": 5, "skillName": "ROS", "amount": "85","img": ros
  },
  { 
    "id": 6, "skillName": "Arduino", "amount": "85" ,"img": arduino
  },
  {
    "id": 7, "skillName": "Ubuntu", "amount": "85","img": ubuntu
  },
  {
    "id": 8, "skillName": "JS", "amount": "75","img": js
  },
  {
    "id": 9, "skillName": "ReactJs", "amount": "70","img": react
  },
  {
    "id": 10, "skillName": "Git", "amount": "70","img": git
  },
  {
    "id": 11, "skillName": "OpenCV", "amount": "65","img": opencv
  },
  { 
    "id": 12, "skillName": "PyTorch","amount": "65" ,"img": pytorch
  },
  {
    "id": 13, "skillName": "Raspberry PI", "amount": "60","img": raspberry
  }
]

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'DFB-CNN',
    description:
      'My Beloved master thesis output, this is a novel neural network architecture that can take advantage of multi scale EEG signal and frequency band encoded information',
    stack: ['EEG','Python', 'MATLAB'],
      },
  {
    name: 'Crack Detection System',
    description:
      "An online system that detects cracks in conveyor belts carrying boulders to prevent the dramatic spread of these cracks. My main contribution was developing a model to detect these cracks. Also, Ideveloped the user interface and a framework to handle and process the collected data from the site.",
    stack: ['Python', 'C++', 'TensorFlow', 'OpenCv'],
    },
  {
    name: 'Traffic Control for Haul Trucks Movement',
    description:
      "Haul trucks that carry molten rocks can not hit the break because of the fluctuation of molten copper. We designed a system with UHF RFID for detecting trucks and a hydraulic boom barrier to block other roads in intersections to facilitate trucks' movements. Additionally, a user interface was developed to collect traffic data for further analysis",
    stack: ['Python', 'Qt', 'MYSQL'],
  },
  {
    name: 'VINS-Mono: Parallax feature representation and Adaptive constraint window',
    description:
      "In this project, I added the features mentioned above to this platform. Also, I prepared the basis for adding an IMU denoiser. \n if you are interested email me for the source code of this project",
    stack: ['C++', 'ROS', 'OpenCV'],
  },
  {
    name: 'Stage Training Strategy',
    description:
      "Implementation and Code can be found in the repo",
    stack: ['EEG','Python', 'TensorFlow'],
    sourceCode: 'https://github.com/mj-sam/stage-trans',
    livePreview: 'https://github.com/mj-sam/stage-trans',
  },
  {
    name: 'Artam Web Application With Hierarchical Recruitment',
    description:
      "Initial implementation in the repo below",
    stack: ['NodeJs', 'ReactJs'],
    sourceCode: 'https://github.com/mj-sam/Artam_initial_server',
  },
  {
    name: 'Smart Hydroponic Irrigation System',
    description:
      "This is actually a hobby project; Still, I like it to be on my portofolio. This platform automatically controlls the water circulation, artificial lights, and adds the dilluted fertelizer after checking Ph level",
    stack: ['Arduino', 'Raspberry PI', 'Python'],
  },
  {
    name: 'RC car controlled by hand position w.r.t webcam',
    description:
      "Imagine an RC car controlled by your hand movement in front of camera. This is it :))",
    stack: ['Arduino', 'Raspberry PI', 'Python'],
  },
  {
    name: '',
    description:
      "Check out my GitHub repos for projects with their source codes",
    stack: [],
    sourceCode: 'https://github.com/mj-sam/',
  },
]

const langs = [
  {
    "id": 14,"langName": "Persian","amount": "100"
  },
  {
    "id": 15,"langName": "English","amount": "90"
  },
  {
    "id": 16,"langName": "Arabic","amount": "40"
  },
  {
    "id": 17,"langName": "French","amount": "30"
  }
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'sameryq@gmail.com',
}

export {skills, header, about, projects, contact, langs}
